import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    data() {
        return {
            loadingConstants: false,
            constants: {},
        }
    },
    methods: {
        ...mapActions({
            FetchConstants: 'enterpriseDataApi/FetchConstants',
        }),
        LoadConstants() {
            if (!!this.constants.CurrentAcademicYear) eventBus.$emit('constants-fetch:success');
            else {
                this.loadingConstants = true;
                this.FetchConstants()
                    .then(response => {
                        this.constants = response;
                        eventBus.$emit('constants-fetch:success');
                    })
                    .catch(error => eventBus.$emit('alert:error', error))
                    .finally(() => this.loadingConstants = false);
            }
        }
    }
};